"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onOnline = void 0;
var once_1 = require("../utils/once");
var once = new once_1.Once();
var registered = false;
function onOnline(defaultView, callback) {
    once.add(callback);
    if (registered || !defaultView)
        return;
    defaultView.addEventListener('online', function () {
        once.emit();
    });
    registered = true;
}
exports.onOnline = onOnline;
//# sourceMappingURL=onOnline.js.map